var PES = PES || {};

PES.OtlTemplatesPage = function () {
    function formatNumber(num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }    

    var init = function (templateRatingUrl, templateDownloadsTrackingUrl) {
        $("a.toggle-description-size").on("click", function () {
            $("div.description").toggleClass("collapsed");
            $("span.state-collapsed").toggle();
            $("span.state-uncollapsed").toggle();
            $("div.description > p").toggleClass("small-p");
            $("hr").toggle();
        });

        $(".zoom").each(function () { $(this).zoom(); });

        $(".rateit").each(function () {
            if (window.localStorage.getItem($(this).attr("template-id"))) {
                $(this).rateit("readonly", true);
            } else {
                $(this).bind("rated", function (event, value) {
                    var rateIt = this;
                    $.ajax({
                        url: templateRatingUrl,
                        type: "POST",
                        data: {
                            templateId: $(rateIt).attr("template-id"),
                            ratedValue: value
                        },
                        success: function (response) {
                            if (response != "") {
                                $("#thanks-for-voting").removeClass("no-display");
                                $(rateIt).rateit("value", response);
                                $(rateIt).rateit("readonly", true);
                                window.localStorage.setItem($(rateIt).attr("template-id"), "rated");
                            } else {
                                $(rateIt).rateit("readonly", true);
                            }
                        }
                    });
                });
            }
        });

        $(".track-download").each(function () {
            $(this).bind("click", function () {
                const templateId = $(this).data("template");
                $.ajax({
                    url: templateDownloadsTrackingUrl,
                    type: "POST",
                    data: {
                        templateId: templateId
                    },
                    success: function (response) {
                        if (response === "Downloaded") {
                            var downloadsId = "downloads-" + templateId;
                            if (document.getElementById(downloadsId)) {
                                var noDownloadsElement = $("#" + downloadsId);
                                var oldValue = parseInt(noDownloadsElement.text().replace(",", ""), 10);
                                if (!isNaN(oldValue)) {
                                    oldValue += 1;
                                    noDownloadsElement.text(formatNumber(oldValue));
                                }
                            }
                        }
                    }
                });
            });
        });
    }

    return {
        Init: init
    }
}